export default "__VITE_ASSET__qbTXi3TN__"